<template>
  <div>    
    <div class="card">
      <Toolbar class="mb-4">
        <template #start>
          <Button
            label="Server hinzufügen"
            icon="pi pi-plus"
            class="p-button-success mr-2"
            @click="openNew"
          />
          <Button
            label="Server löschen"
            icon="pi pi-trash"
            class="p-button-danger"
            @click="confirmDeleteSelected"
            :disabled="!selectedIOs || !selectedIOs.length"
          />
        </template>

        <template #end>
          <FileUpload
            mode="basic"
            accept="image/*"
            :maxFileSize="1000000"
            label="Import"
            chooseLabel="Import"
            class="mr-2 d-inline-block"
          />
          <Button
            label="Export"
            icon="pi pi-upload"
            class="p-button-help"
            @click="exportCSV($event)"
          />
        </template>
      </Toolbar>

      <DataTable
        ref="dt"
        :value="io_type"
        v-model:selection="selectedIOs"
        dataKey="_id"
        :loading="loading"
        :paginator="true"
        :rows="50"
        :filters="filters"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 50, 100]"
        currentPageReportTemplate="Zeige {first} bis {last} von {totalRecords} Einträgen"
        responsiveLayout="scroll"
      >
        <template #loading> Daten werden geladen... bitte warten </template>
        <template #header>
          <div
            class="
              table-header
              d-flex flex-column flex-md-row jc-md-between
            "
          >
            <h5 class="mb-2 m-md-0 as-md-center">Server</h5>
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="filters['global'].value"
                placeholder="suchen..."
              />
            </span>
          </div>
        </template>

        <Column selectionMode="multiple" :exportable="false"></Column>
        <Column field="value" header="Host" :sortable="true"></Column>
        <Column field="path" header="Pfad" :sortable="true"></Column>
        <Column field="label" header="Bezeichnung" :sortable="true"></Column>
        <Column :exportable="false" style="min-width: 8rem">
          <template #body="slotProps">
            <Button
              icon="pi pi-pencil"
              class="p-button-rounded p-button-success mr-2"
              @click="editIO(slotProps.data)"
            />
            <Button
              icon="pi pi-trash"
              class="p-button-rounded p-button-warning"
              @click="confirmDeleteIO(slotProps.data)"
            />
          </template>
        </Column>
      </DataTable>
    </div>

    <Dialog
      v-model:visible="ioDialog"
      :style="{ width: '450px' }"
      header="Kategorien bearbeiten"
      :modal="true"
      class="p-fluid"
      @hide="hideDialog"
    >
      <div class="field">
        <label for="value">Name</label>
        <InputText
          id="value"
          v-model.trim="ioDialogData.value"
          required="true"
          autofocus
          :class="{ 'p-invalid': submitted && !ioDialogData.value }"
        />
        <small class="p-error" v-if="submitted && !ioDialogData.value"
          >Name <b>muss</b> ausgefüllt werden!</small
        >
      </div>
      <div class="field">
        <label for="label">Applikation-Pfad</label>
        <Textarea
          id="path"
          v-model="ioDialogData.path"
          required="true"
          rows="3"
          cols="20"
        />
      </div>
      <div class="field">
        <label for="label">Bezeichnung</label>
        <Textarea
          id="desc"
          v-model="ioDialogData.label"
          required="true"
          rows="2"
          cols="20"
        />
      </div>

      <template #footer>
        <Button
          label="Abbrechen"
          icon="pi pi-times"
          class="p-button-text"
          @click="hideDialog"
        />
        <Button
          label="Speichern"
          icon="pi pi-check"
          class="p-button-text"
          @click="saveIO"
        />
      </template>
    </Dialog>

    <Dialog
      v-model:visible="deleteIoDialog"
      :style="{ width: '450px' }"
      header="Bestätigung"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <span v-if="ioDialogData"
          >Soll der Eintrag wirklich aus der Datenbank gelöscht werden: <br />
          <span style="font-family:LogFileFont; color: yellow;">{{ ioDialogData.label }}</span> ?</span
        >
      </div>
      <template #footer>
        <Button
          label="Nein"
          icon="pi pi-times"
          class="p-button-text"
          @click="deleteIoDialog = false"
        />
        <Button
          label="Ja"
          icon="pi pi-check"
          class="p-button-text"
          @click="deleteIO"
        />
      </template>
    </Dialog>

    <Dialog
      v-model:visible="deleteIosDialog"
      :style="{ width: '450px' }"
      header="Bestätigung"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <span v-if="ioDialogData"
          >Sollen die Einträge wirklich aus der Datenbank gelöscht werden?</span
        >
      </div>
      <template #footer>
        <Button
          label="Nein"
          icon="pi pi-times"
          class="p-button-text"
          @click="deleteIosDialog = false"
        />
        <Button
          label="Ja"
          icon="pi pi-check"
          class="p-button-text"
          @click="deleteSelectedIOs"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import helpers from "@/helpers";
import { FilterMatchMode } from "primevue/api";
// import ProductService from "../helpers";
// import mainService from "@/services/mainService.js";
import SocketioService from "@/services/socketioService.js";
// import socketioService from "@/services/socketioService.js";

export default {
  name: "config_io_server",
  data() {
    return {
      loading: false,
      ioDialog: false,
      deleteIoDialog: false,
      deleteIosDialog: false,
      ioDialogData: {},
      config_io: null,
      io_type: null,
      selectedIOs: null,
      filters: {},
      submitted: false,
      intval_Value: null,
      elementIndex: -1,
    };
  },
  created() {
    this.initFilters();
  },
  mounted() {
    // this.productService.getProducts().then((data) => (this.products = data));
    this.loading = true;
    this.getParameter();
    this.registerSocketIoEvents();
  },
  beforeUnmount() {
    this.unregisterSocketIoEvents();
  },
  methods: {
    resetDialogData() {
      this.ioDialogData = {
        // group: {},
      };
      this.elementIndex = -1;
    },
    getParameterConfigIO() {
      SocketioService.getServerData("config", 'io', (err, response) => {
        this.config_io = response;
        this.io_type = response.types_server;
        this.loading = false;
      });
      // SocketioService.getConfigIO((response) => {
      //   this.config_io = response;
      //   this.io_type = response.types_server;
      //   this.loading = false;
      //   // this.io_department = response.types_department;
      //   // this.io_types = response.types_io;
      //   // this.io_unit = response.types_unit;
      //   // this.io_server = response.types_server;
      //   // this.io_icons = response.types_icons;
      // });
    },
    getParameter() {
      this.getParameterConfigIO();
    },
    registerSocketIoEvents() {
      SocketioService.socket.on("set_config_io_type_server_result", (data) => {
        if (data !== null) {
          this.getParameter();
          // document not changed
          if (
            data.acknowledged &&
            data.matchedCount > 0 &&
            data.upsertedCount === 0 &&
            data.modifiedCount === 0
          ) {
            this.$toast.add({
              severity: "info",
              summary: "Eintrag unverändert",
              detail:
                "modifiziert: " +
                data.modifiedCount +
                " , keine Änderung notwendig ",
              life: 3000,
            });
            // document updated
          } else if (
            data.acknowledged &&
            data.matchedCount > 0 &&
            data.upsertedCount === 0 &&
            data.modifiedCount > 0
          ) {
            this.$toast.add({
              severity: "success",
              summary: "Eintrag geändert",
              detail:
                "modifiziert: " +
                data.modifiedCount +
                " , alle Änderungen wurden gespeichert ",
              life: 3000,
            });
            // document deleted
          } else if (data.acknowledged && data.deletedCount > 0) {
            this.$toast.add({
              severity: "success",
              summary: "Eintrag gelöscht",
              detail: data.deletedCount + " Einträge erfolgreich gelöscht",
              life: 3000,
            });
            // document created
          } else if (data.acknowledged && data.insertedId !== null) {
            this.$toast.add({
              severity: "success",
              summary: "Eintrag erstellt",
              detail:
                "Eintrag mit Name [" +
                data.insertedId.toString() +
                "] erfolgreich erstellt",
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Eintrag nicht durchgeführt",
              detail:
                "modifiziert: " +
                data.modifiedCount +
                " , Erstellt: " +
                data.upsertedCount +
                " [" +
                data.upsertedId +
                "]",
              life: 3000,
            });
          }
        }
      });
    },
    unregisterSocketIoEvents() {
      SocketioService.socket.removeAllListeners("set_config_io_type_server_result");
    },
    openNew() {
      this.resetDialogData();
      this.submitted = false;
      this.ioDialog = true;
    },
    hideDialog() {
      this.ioDialog = false;
      this.submitted = false;
      // clearInterval(this.intval_Value);
      this.getParameter();
    },
    saveIO() {
      this.submitted = true;

      if (this.ioDialogData.value.trim()) {
        // let _index = helpers.findIndexByName(this.io_type, this.ioDialogData.value);
        if (this.elementIndex >= 0) {
          this.io_type[this.elementIndex] = this.ioDialogData;
          SocketioService.setConfigIOType(this.io_type, "types_server");
        } else {
          let _size = Object.keys(this.io_type).length;
          this.io_type[_size] = this.ioDialogData;
          SocketioService.setConfigIOType(this.io_type, "types_server");
        }
        // clearInterval(this.intval_Value);
        this.ioDialog = false;
        this.resetDialogData();
      }
    },
    editIO(ioData) {
      // this.ioDialogData = { ...ioData };
      this.getParameter();
      const _obj = JSON.parse(JSON.stringify(ioData));
      this.elementIndex = helpers.findIndexByName(this.io_type, _obj.value);
      this.ioDialogData = _obj;
      this.ioDialog = true;
    },
    confirmDeleteIO(ioData) {
      const _obj = JSON.parse(JSON.stringify(ioData));
      this.ioDialogData = _obj;
      this.deleteIoDialog = true;
    },
    deleteIO() {
      let _index = helpers.findIndexByName(this.io_type, this.ioDialogData.value);
      if (_index >= 0) {
        this.io_type.splice(_index, 1);
        SocketioService.setConfigIOType(this.io_type, "types_server");
        // SocketioService.removeUser(this.system_user[_index]);
        // this.$toast.add({
        //   severity: "success",
        //   summary: "Successful",
        //   detail: "Product Updated",
        //   life: 3000,
        // });
      } else {
        // this.product.id = this.createId();
        // this.product.code = this.createId();
        // this.product.image = "product-placeholder.svg";
        // this.products.push(this.product);
        // this.$toast.add({
        //   severity: "success",
        //   summary: "Successful",
        //   detail: "Product Created",
        //   life: 3000,
        // });
      }
      this.deleteIoDialog = false;
      this.resetDialogData();
      // this.$toast.add({
      //   severity: "success",
      //   summary: "Successful",
      //   detail: "Product Deleted",
      //   life: 3000,
      // });
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    confirmDeleteSelected() {
      this.deleteIosDialog = true;
    },
    deleteSelectedIOs() {
      SocketioService.removeValue(this.selectedIOs);
      this.deleteIosDialog = false;
      this.selectedIOs = null;
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
};
</script>

<style lang="scss" scoped>

</style>